<template>
  <v-dialog v-model="dialog.show" max-width="400" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row align="center">
            <v-col cols="6" v-show="!dialog.edit">
              <v-text-field
                v-model="prazoId"
                :rules="[rules.required, rules.isNumber]"
                label="Prazo"
                prefix="x"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="prazo.tc"
                :rules="[rules.required, rules.isNumber]"
                label="Valor TC"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="prazo.coeficienteSPF"
                :rules="[rules.required, rules.isNumber]"
                label="Coeficiente SPF"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="prazo.taxaMes"
                :rules="[rules.required, rules.isNumber]"
                label="Taxa Mês"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="prazo.taxaAno"
                :rules="[rules.required, rules.isNumber]"
                label="Taxa Ano"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-checkbox v-model="prazo.ativo" label="Ativo"></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="dialog.edit ? editItem() : save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import Prazo from "@/services/prazo";

export default {
  name: "DialogFormPrazo",

  data() {
    return {
      dialog: {
        show: false,
        title: "",
        edit: false
      },
      prazo: {
        ativo: true,
        tc: "",
        coeficienteSPF: "",
        taxaMes: "",
        taxaAno: ""
      },
      prazoId: "",
      financiamento: null,
      rules,
      servicePrazo: new Prazo()
    };
  },

  methods: {
    show(edit, prazo, financiamento) {
      this.financiamento = financiamento;
      if (edit) {
        this.prazoId = prazo.id;
        this.prazo.ativo = prazo.ativo;
        this.prazo.tc = prazo.tc;
        this.prazo.coeficienteSPF = prazo.coeficienteSPF;
        this.prazo.taxaMes = prazo.taxaMes;
        this.prazo.taxaAno = prazo.taxaAno;
        this.dialog.edit = true;
        this.dialog.title = `Editar Prazo ${prazo.id}`;
      } else {
        this.dialog.edit = false;
        this.dialog.title = "Novo Prazo";
      }
      this.dialog.show = true;
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.convertValuesToFloat();
        try {
          const response = await this.servicePrazo.createPrazoFinanciamentoProdutoForca(
            this.financiamento,
            { ...this.prazo },
            this.prazoId
          );
          this.$emit("created", response);
          this.close();
          return Promise.resolve();
        } catch (error) {
          this.$toast.error("Erro ao cadastrar Prazo");
          return Promise.reject(error);
        }
      }
    },

    async editItem() {
      if (this.$refs.form.validate()) {
        this.convertValuesToFloat();
        try {
          const response = await this.servicePrazo.updatePrazoFinanciamentoProdutoForca(
            this.financiamento,
            { ...this.prazo },
            this.prazoId
          );
          this.$emit("updated", response);
          this.close();
          return Promise.resolve();
        } catch (error) {
          this.$toast.error("Erro ao atualizar Prazo");
          return Promise.reject(error);
        }
      }
    },

    close() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.dialog.show = false;
    },

    convertValuesToFloat() {
      this.prazo.tc = parseFloat(this.prazo.tc);
      this.prazo.coeficienteSPF = parseFloat(this.prazo.coeficienteSPF);
      this.prazo.taxaMes = parseFloat(this.prazo.taxaMes);
      this.prazo.taxaAno = parseFloat(this.prazo.taxaAno);
    }
  }
};
</script>
